import React from 'react';
import "./index.scss";
import Topbar from "../../../HomePage/components/Topbar/index.jsx";
import { Affix, Avatar, Calendar } from 'antd';


export default class ColumnContent extends React.Component {
  render() {

    return (<div className="ColumnBackground">
      <Topbar></Topbar>
      <div className="ConnentColumn">
    
        <div className="ColumnBox">
          <h1>这是大新闻</h1>
          <h2>这是时间</h2>
          <h3>CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。CSS3 渐变(gradients)可以让你在两个或多个指定的颜色之间显示平稳的过渡。以前,你必须使用图像来实现这些效果。但是,通过使用 CSS3 渐变(gradients),你可以减少下载的时间和宽带的使用。</h3>
        </div>
        <div className="AboutBox"><Affix>
          <div className="AvatarBox">
            <Avatar
              size={80}
              src="https://camo.githubusercontent.com/c26f325fa8d482c5dfbc30be326e4ce27ac2ea70e1db3facf269bcb40de16a11/68747470733a2f2f73312e617831782e636f6d2f323032302f30392f30382f774d723373782e74682e6a7067"
              alt="sagio"
            />
            <h2>sagio</h2>
            <div className="site-calendar-demo-card">
            <Calendar fullscreen={false} />
            </div>
            
            </div>
        </Affix>
        </div>
      </div>
    </div>
    )
  }
}